import React, { useState, useEffect } from "react";
import { Col, Empty, Row, Space, Tag, Spin, Collapse } from "antd";
import axios from "axios";
import API from "@/api";
import "./index.less";
import SjlyImg from "../../../../assets/images/sjlyImg.svg";

const { Panel } = Collapse;

function SjlyData(props) {
  const { question_id } = props;
  const [defaultData, setDefaultDataData] = useState([]);
  const [moreData, setMoreData] = useState([]);
  const [spining, setSpining] = useState(true);
  const [defaultKey, setDefaultKey] = useState([]);
  const [moreKey, setMoreKey] = useState([]);

  useEffect(() => {
    axios
      .post(API.getSjly, {
        question_id: question_id,
        related_to_message: false,
      })
      .then((res) => {
        const data = res?.data?.data_sources || [];
        console.log(data);
        const arr = [];
        const arr1 = [];
        data.map((item) => {
          if (item.related_to_message) {
            arr.push(item);
          } else {
            arr1.push(item);
          }
        });
        setDefaultDataData(arr);
        setDefaultKey([arr?.[0]?.table_ref || ""]);
        setMoreData(arr1);
        setMoreKey([arr1?.[0]?.table_ref || ""]);
        setSpining(false);
      });
  }, []);

  return (
    <div className="sjly">
      <Spin spinning={spining}>
        {defaultData && defaultData.length ? (
          <>
            <div className="defaultData">
              <div className="title">
                当前图表数据
                {defaultData && defaultData.length
                  ? "（" + defaultData.length + "）"
                  : ""}
              </div>
              <Collapse
                accordion={true}
                bordered={false}
                activeKey={defaultKey}
                onChange={(key) => {
                  setDefaultKey(key);
                }}
              >
                {defaultData.map((item) => {
                  return (
                    <Panel key={item.table_ref} header={item.table_label}>
                      <div className="listItem">
                        <div
                          className="gjzb"
                          style={{
                            padding:
                              item.metrics && item.metrics.length
                                ? " 5px 0"
                                : "unset",
                          }}
                        >
                          <Row gutter={[16, 16]}>
                            {item.metrics && item.metrics.length ? (
                              <>
                                <Col span={3}>
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      color: "#777",
                                    }}
                                  >
                                    关键指标
                                  </span>
                                </Col>
                                <Col span={21}>
                                  {item.metrics && item.metrics.length ? (
                                    <Space wrap={true} className="metrics">
                                      {item.metrics.map((jtem) => {
                                        return <Tag>{jtem.name}</Tag>;
                                      })}
                                    </Space>
                                  ) : undefined}
                                </Col>
                              </>
                            ) : undefined}
                          </Row>
                        </div>
                        <div
                          className="gjzb"
                          style={{
                            padding:
                              item.dimensions && item.dimensions.length
                                ? " 5px 0"
                                : "unset",
                          }}
                        >
                          <Row>
                            {item.dimensions && item.dimensions.length ? (
                              <>
                                <Col span={3}>
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      color: "#777",
                                    }}
                                  >
                                    分析维度
                                  </span>
                                </Col>
                                <Col span={21}>
                                  {item.dimensions && item.dimensions.length ? (
                                    <Space wrap className="dimension">
                                      {item.dimensions.map((jtem) => {
                                        return <Tag>{jtem.name}</Tag>;
                                      })}
                                    </Space>
                                  ) : undefined}
                                </Col>
                              </>
                            ) : undefined}
                          </Row>
                        </div>
                      </div>
                    </Panel>
                  );
                })}
              </Collapse>
            </div>
            <div className="moreData defaultData">
              <div className="title">
                更多数据
                {moreData && moreData.length
                  ? "（" + moreData.length + "）"
                  : ""}
              </div>
              <Collapse
                accordion={true}
                bordered={false}
                activeKey={moreKey}
                onChange={(key) => {
                  setMoreKey(key);
                }}
              >
                {moreData.map((item) => {
                  return (
                    <Panel key={item.table_ref} header={item.table_label}>
                      <div className="listItem">
                        <div
                          className="gjzb"
                          style={{
                            padding:
                              item.metrics && item.metrics.length
                                ? " 5px 0"
                                : "unset",
                          }}
                        >
                          <Row gutter={[16, 16]}>
                            {item.metrics && item.metrics.length ? (
                              <>
                                <Col span={3}>
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      color: "#777",
                                    }}
                                  >
                                    关键指标
                                  </span>
                                </Col>
                                <Col span={21}>
                                  {item.metrics && item.metrics.length ? (
                                    <Space wrap={true} className="metrics">
                                      {item.metrics.map((jtem) => {
                                        return <Tag>{jtem.name}</Tag>;
                                      })}
                                    </Space>
                                  ) : undefined}
                                </Col>
                              </>
                            ) : undefined}
                          </Row>
                        </div>
                        <div
                          className="gjzb"
                          style={{
                            padding:
                              item.dimensions && item.dimensions.length
                                ? " 5px 0"
                                : "unset",
                          }}
                        >
                          <Row gutter={[16, 16]}>
                            {item.dimensions && item.dimensions.length ? (
                              <>
                                <Col span={3}>
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      color: "#777",
                                    }}
                                  >
                                    分析维度
                                  </span>
                                </Col>
                                <Col span={21}>
                                  {item.dimensions && item.dimensions.length ? (
                                    <Space wrap className="dimension">
                                      {item.dimensions.map((jtem) => {
                                        return <Tag>{jtem.name}</Tag>;
                                      })}
                                    </Space>
                                  ) : undefined}
                                </Col>
                              </>
                            ) : undefined}
                          </Row>
                        </div>
                      </div>
                    </Panel>
                  );
                })}
              </Collapse>
            </div>
          </>
        ) : (
          <Empty />
        )}
      </Spin>
    </div>
  );
}

export default SjlyData;
